import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import React from 'react';
import './ExclusiveButtons.scss';

interface Option {
  label: string;
  value: any;
}

interface Props {
  data: Option[];
  value: any;
  onChange?: (event: React.MouseEvent, value: any) => void;
}

export const ExclusiveButtons = ({ data, value, onChange }: Props) => {
  const _onChange = (event: React.MouseEvent, newValue: any) => {
    if (newValue && newValue !== value) {
      onChange(event, newValue);
    }
  };

  return (
    <ToggleButtonGroup
      className="exclusive-buttons-group"
      value={value}
      exclusive
      onChange={_onChange}
    >
      {data.map(({ label, value }) => (
        <ToggleButton key={value} className="exclusive-button" value={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
